import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@material-ui/core'

const Section = ({ accent, children, ...props }) => (
  <Box component={'section'} bgcolor={accent ? '#F9F9F9' : 'none'} {...props}>
    <Container>{children}</Container>
  </Box>
)

Section.defaultProps = {
  py: [4, 8],
  accent: false,
}
Section.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Section
